<template>
  <ModalDialog
    ref="dialog"
    title="Confirm Goods Received"
    :submitting="submitting"
    submitTitle="Confirm"
    icon="fa-dolly-flatbed"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3">
      <NotificationBar type="warning" v-if="containsMissingBatchInfo()">
        <NotificationBarTitle>The following warnings were found in the receiving list:</NotificationBarTitle>
        <NotificationBarItem v-if="containsMissingBatchInfo()">Some goods have missing supplier batch details</NotificationBarItem>
      </NotificationBar>

      <NotificationBar type="warning">
        <NotificationBarTitle>This will process the received goods into the inventory system. This action cannot be undone</NotificationBarTitle>
      </NotificationBar>
      
      <FormRow label="Goods Received Notes">
        <FormInputTextArea v-model="info.notes" field="notes" placeholder="Goods Receiving Notes" large />
      </FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

export default {
  name: "GoodsReceivedDialog",
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog,
  },
  props: {
    purchaseOrderId: Number,
    goodsReceivedList: Array
  },
  data() {
    return {
      responseInfo: {},
      dialogForm: {},
      submitting: false,
      info: {}
    }
  },
  mounted() {    
  },
  computed: {
  },
  methods: {
    show() {
      // Reset form
      this.responseInfo = { }
      this.dialogForm = { }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var receivingDetails = {
        notes: this.info.notes
      }

      this.$apiService.purchasingService.completePurchaseOrderGoodsReceived(this.$route.params.id, receivingDetails)
      .then(response => {
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.$data.dialogForm = this.processFormResponse(err)
      })
      .finally(() => {
        this.$data.submitting = false
      })
    },

    containsMissingBatchInfo() {
      if(!this.goodsReceivedList)
        return false
      return this.goodsReceivedList.filter(item => {
        if((item.supplierBatchRef == null || item.supplierBatchRef == '')) {
          if(item.isBlock && parseInt(item.blockSize) > 0)
            return true
          if(!item.isBlock && item.quantity > 0)
            return true
        }
        return false
      }).length > 0
    }
  }
}
</script>